import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';
import * as util from 'notebook/tables/excess/Util';

export default {
  name: 'NOT',
  shortDescription: 'Logical NOT operator.',
  category: FunctionCategory.LOGIC,
  description: 'Returns the opposite of a logical value. NOT(TRUE) returns FALSE; NOT(FALSE) returns TRUE.',
  params: [
    {
      name: 'logical_expression',
      type: ArgType.any,
      description:
        'An expression or reference to a cell containing an expression that represents some logical value, i.e. TRUE or FALSE.',
    },
  ],
  eval: (operand): boolean => {
    if (typeof operand !== 'boolean') {
      throw new util.ValueError(
        'Function NOT parameter has wrong type. Its value should be either TRUE or FALSE.'
      );
    }
    return !operand;
  },
} satisfies EvaluablePrimitiveSpreadsheetFunction;
